{
	"title": "Service niet beschikbaar (500)",
	"description": "Probeer deze pagina te verversen of controleer je internetverbinding. Als deze fout blijft optreden, meld deze dan als bug zodat we actie kunnen ondernemen.",
	"primaryButtonTitle": "Pagina verversen",
	"secondaryButtonTitle": "Foutenlog kopiëren",
	"errorLogCopiedMessage": "Foutenlog gekopieerd",
	"traceparentLabel": "Traceparent"
}
